var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tag',{staticClass:"kst-status",class:_vm.theClass,attrs:{"type":"is-flex is-size-6 py-1 ks-is-fullwidth kst-status"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }